<template>
  <div class="adventures">
    <top-nav ref="TopNav"></top-nav>
    <van-nav-bar title="积分大转盘" fixed left-arrow @click-left="goBack" @click-right="onClickRight">
      <van-icon slot="right" class="iconfont icon-zhankai"></van-icon>
    </van-nav-bar>
    <div class="van-content">
      <div class="usertit"><img src="/static/images/adventures-usertit.png" />
        <span v-if="userdatas != ''">您今天还剩{{ userdatas.day_conut }}次抽奖机会</span>
        <span v-else>您还未登录</span>
      </div>
      <div class="awardRotate">
        <!--<img src="/static/images/countbanner.png" id="shan-img" style="display:none;" />-->
        <!--<img src="/static/images/hotactimg.jpg" id="sorry-img" style="display:none;" />-->
        <div class="banner">
          <div class="turnplate">
            <canvas class="item" id="wheelcanvas" width="422px" height="422px"></canvas>
            <img class="pointer" src="/static/images/pointer.png"  v-on:click="pointer"/>
          </div>
          <div class="turnplate-bottom"><img src="/static/images/turnplate-bottom.png"/></div>
        </div>
      </div>
      <van-row class="adventures-bot-btn">
        <van-col span="12"><van-button size="small" @click="showPlay(2,true)">活动规则</van-button></van-col>
        <van-col span="12"><van-button size="small" @click="showList(1,true)">中奖名单</van-button></van-col>
      </van-row>
    </div>
    <!--中奖名单-->
    <van-popup v-model="show1" class="adven-popup userlist-popup">
      <div class="hintbox">
        <div class="hintclear" @click="showPlay(1,false)"><img src="/static/images/adventures-clear.png"/></div>
        <div class="hintcent">
          <div class="hinttit">中奖名单</div>
          <van-row v-for="(items,index) in userlist" class="userlist" :key="index" v-if="userlist != ''">
            <van-col span="10">{{ items.mobile }}</van-col>
            <van-col span="7">{{ items.prizename }}</van-col>
            <van-col span="7">{{ items.prize_name }}</van-col>
          </van-row>
          <van-row v-else>
            <van-col span="10">暂无用户获奖</van-col>
          </van-row>
        </div>
      </div>
    </van-popup>
    <!--规则-->
    <van-popup v-model="show2" class="adven-popup rule-popup">
      <div class="hintbox">
        <div class="hintclear" @click="showPlay(2,false)"><img src="/static/images/adventures-clear.png"/></div>
        <div class="hintcent">
          <div class="hinttit">活动规则</div>
          <div>
            <p class="tit">活动时间：</p>
            <p v-if="datas != ''">{{ datas.activity_config.activity_start_time  }}——{{ datas.activity_config.activity_end_time }}</p>
            <p class="tit">奖项设置（积分）：</p>
            <p v-for="items in datas.activity_info" :key="items.name">{{ items.name }}&nbsp;&nbsp;&nbsp;&nbsp;{{ items.name }}奖品&nbsp;&nbsp;&nbsp;&nbsp;{{ items.prize_name }}  </p>
            <p class="tit">活动规则：</p>
            <p v-html="datas.activity_config.activity_introduce" v-if="datas !=''"></p>
          </div>
          <div class="text-cent">
            <van-button size="small" @click="showPlay(2,false)">我知道了</van-button>
          </div>
        </div>
      </div>
    </van-popup>
    <!--未中奖-->
    <van-popup v-model="show3" class="adven-popup false-popup">
      <div class="hintbox">
        <div class="hintclear" @click="showPlay(3,false)"><img src="/static/images/adventures-clear.png"/></div>
        <div class="hintcent">
          <img src="/static/images/adven-popup-false.png"/>
          <div>
            <van-button size="small" @click="showPlay(3,false)">我知道了</van-button>
          </div>
        </div>
      </div>
    </van-popup>
    <!--中奖-->
    <van-popup v-model="show4" class="adven-popup true-popup">
      <div class="hintbox">
        <div class="hintclear" @click="showPlay(4,false)"><img src="/static/images/adventures-clear.png"/></div>
        <div class="truetext">获得{{ truetext }}</div>
        <div class="hintcent">
          <img src="/static/images/adven-popup-true.png"/>
          <div>
            <van-button size="small" @click="showPlay(4,false)">我知道了</van-button>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import TopNav from "@/components/topnav";
import { myfun } from "../../assets/js/awardRotate";
import "mint-ui/lib/style.css";
import { Toast } from "mint-ui";
export default {
  name: "adventures",
  components: {
    TopNav,
    myfun
  },
  data() {
    return {
      datas: "",
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      userdatas: "",
      truetext: "",
      userlist: [],
      msg: "",
      turnplate: {
        restaraunts: [], //奖项设置
        colors: [], //奖项背景颜色
        outsideRadius: 160, //半径
        textRadius: 125, //圆角半径
        insideRadius: 60, //内圆角半径
        startAngle: 0,
        bRotate: false
      }
    };
  },
  created() {
    this.$nextTick(() => {
      this.turnplate.restaraunts = [
        "大吉大利!",
        "大吉大利!",
        "大吉大利!",
        "大吉大利!",
        "大吉大利!"
      ];
      this.turnplate.colors = ["rgba(0,0,0,0)"];
      this.drawRouletteWheel();
    });
    this.getUserdatas();
    this.getDatas();
  },
  methods: {
    goBack: function() {
      history.back(-1);
    },
    onClickRight() {
      this.$refs.TopNav.topnavPlay();
    },
    showList(index, re) {
      var isUser = localStorage.getItem("BLHuser");
      this.$api.post(
        "/WebApi/Member/Winning/winning",
        { token: isUser },
        res => {
          if (res.data.code == "100") {
            this.userlist = [];
            this.userlist = res.data.data;
            this.show1 = re;
          } else {
            this.$dialog
              .alert({
                title: "提示",
                message: "敬请期待！"
              })
              .then(() => {
                this.$router.push({ path: "/" });
              });
          }
        }
      );
    },
    showPlay: function(index, re) {
      if (index == 1) {
        this.show1 = re;
      } else if (index == 2) {
        this.show2 = re;
      } else if (index == 3) {
        this.show3 = re;
      } else if (index == 4) {
        this.show4 = re;
      }
    },
    getUserdatas: function() {
      var isUser = localStorage.getItem("BLHuser");
      this.$api.post(
        "WebApi/Member/Winning/day_conut",
        { token: isUser },
        res => {
          this.userdatas = res.data.data;
        }
      );
    },
    getDatas: function() {
      var isUser = localStorage.getItem("BLHuser");
      this.$api.post("WebApi/Member/Winning/index", { token: isUser }, res => {
        if (res.data.code == "100") {
          this.getUserlist();
          this.datas = res.data.data;
          this.$nextTick(() => {
            var _this = this;
            this.turnplate.restaraunts = [];
            $.each(res.data.data.activity_info, function(index, items) {
              _this.turnplate.restaraunts.push(items.name);
            });
            this.drawRouletteWheel();
            this.turnplate.bRotate = true;
          });
        } else if (res.data.errCode == "5009") {
          this.$dialog
            .alert({
              title: "提示",
              message: "敬请期待！"
            })
            .then(() => {
              this.$router.push({ path: "/" });
            });
        }
      });
    },
    getUserlist: function() {
      this.$api.post("WebApi/Member/Winning/winning", null, res => {
        this.userlist = res.data.data;
      });
    },
    rotateFn: function(item, txt, status_id) {
      var _this = this;
      var angles =
        item * (360 / this.turnplate.restaraunts.length) -
        360 / (this.turnplate.restaraunts.length * 2);
      if (angles < 270) {
        angles = 270 - angles;
      } else {
        angles = 360 - angles + 270;
      }
      var bRotateT = this.turnplate.bRotate;
      this.$nextTick(() => {
        $("#wheelcanvas").stopRotate();
        $("#wheelcanvas").rotate({
          angle: 0,
          animateTo: angles + 1800,
          duration: 8000,
          callback: function() {
            if (status_id == null) {
              _this.show3 = true;
            } else {
              _this.show4 = true;
              _this.truetext = txt;
            }
            _this.turnplate.bRotate = true;
          }
        });
      });
    },
    pointer() {
      if (this.turnplate.bRotate) {
        this.turnplate.bRotate = false;
        var isUser = localStorage.getItem("BLHuser");
        var _this = this;
        this.$api.post(
          "WebApi/Member/Winning/receivePrizes",
          {
            token: isUser,
            activity_id: this.datas.activity_info[0].activity_id
          },
          res => {
            if (res.data.code == "100") {
              this.userdatas.day_conut = this.userdatas.day_conut - 1;
              var status_id = res.data.data.ok_status_id;
              $.each(this.datas.activity_info, function(index, items) {
                if (items.id == res.data.data.prize_id) {
                  _this.rotateFn(
                    index + 1,
                    _this.turnplate.restaraunts[index],
                    status_id
                  );
                }
              });
              /*if(status_id != null){
                this.$api.post('WebApi/Member/Winning/ok_status', {token:isUser,activity_winning_id:status_id}, res2 => {})
              }*/
            } else if (res.data.errCode == "1002") {
              this.$dialog
                .confirm({
                  title: "提示",
                  message: "您还未登录是否去登录？"
                })
                .then(() => {
                  this.turnplate.bRotate = true;
                  this.$router.push({ path: "/notelogin" });
                })
                .catch(() => {
                  this.turnplate.bRotate = true;
                });
            } else {
              this.turnplate.bRotate = true;
              this.$toast(res.data.message);
            }
          }
        );
      } else {
      }
    },
    drawRouletteWheel() {
      var canvas = document.getElementById("wheelcanvas");
      if (canvas.getContext) {
        // 根据奖品个数计算圆周角度
        var arc = Math.PI / (this.turnplate.restaraunts.length / 2);
        var ctx = canvas.getContext("2d");
        // 在给定矩形内清空一个矩形
        ctx.clearRect(0, 0, 422, 422);
        // strokeStyle 属性设置或返回用于笔触的颜色、渐变或模式
        ctx.strokeStyle = "#FFBE04";
        // font 属性设置或返回画布上文本内容的当前字体属性
        ctx.font = "18px Microsoft YaHei";
        for (var i = 0; i < this.turnplate.restaraunts.length; i++) {
          var angle = this.turnplate.startAngle + i * arc;
          ctx.fillStyle = this.turnplate.colors[i];
          ctx.beginPath();
          //  arc(x,y,r,起始角,结束角,绘制方向) 方法创建弧/曲线（用于创建圆或部分圆）
          ctx.arc(
            211,
            211,
            this.turnplate.outsideRadius,
            angle,
            angle + arc,
            false
          );
          ctx.arc(
            211,
            211,
            this.turnplate.insideRadius,
            angle + arc,
            angle,
            true
          );
          ctx.stroke();
          ctx.fill();
          // 锁画布(为了保存之前的画布状态)
          ctx.save();

          // ----绘制奖品开始----
          ctx.fillStyle = "#2d0c02";
          var text = this.turnplate.restaraunts[i];
          var lineHeight = 17;
          // translate方法重新映射画布上的 (0,0) 位置
          ctx.translate(
            211 + Math.cos(angle + arc / 2) * this.turnplate.textRadius,
            211 + Math.sin(angle + arc / 2) * this.turnplate.textRadius
          );

          // rotate方法旋转当前的绘图
          ctx.rotate(angle + arc / 2 + Math.PI / 2);

          /** 下面代码根据奖品类型、奖品名称长度渲染不同效果，如字体、颜色、图片效果。(具体根据实际情况改变) **/
          if (text.indexOf("M") > 0) {
            // 流量包
            var texts = text.split("M");
            for (var j = 0; j < texts.length; j++) {
              ctx.font =
                j === 0 ? "bold 20px Microsoft YaHei" : "16px Microsoft YaHei";
              if (j === 0) {
                ctx.fillText(
                  texts[j] + "M",
                  -ctx.measureText(texts[j] + "M").width / 2,
                  j * lineHeight
                );
              } else {
                ctx.fillText(
                  texts[j],
                  -ctx.measureText(texts[j]).width / 2,
                  j * lineHeight
                );
              }
            }
          } else if (text.indexOf("M") === -1 && text.length > 6) {
            // 奖品名称长度超过一定范围
            text = text.substring(0, 6) + "||" + text.substring(6);
            var textst = text.split("||");
            for (var ji = 0; ji < textst.length; ji++) {
              ctx.fillText(
                textst[ji],
                -ctx.measureText(textst[ji]).width / 2,
                ji * lineHeight
              );
            }
          } else {
            // 在画布上绘制填色的文本。文本的默认颜色是黑色
            // measureText()方法返回包含一个对象，该对象包含以像素计的指定字体宽度
            ctx.fillText(text, -ctx.measureText(text).width / 2, 0);
          }

          // 添加对应图标
          /*if (text.indexOf('Q币') > 0) {
              var img = document.getElementById('shan-img')
              img.onload = function () {
                // ctx.drawImage(img, -15, 10) //本来第一次加载大转盘抽奖就会出现奖品图片，但是有点瑕疵没有解决所以注释了，现在第二次加载就会出现，
                //谁解决了来说下，帮助大家
              }
              ctx.drawImage(img, -15, 10)
            } else if (text.indexOf('谢谢参与') >= 0) {
              img = document.getElementById('sorry-img')
              img.onload = function () {
                // ctx.drawImage(img, -15, 10) //本来第一次加载大转盘抽奖就会出现奖品图片，但是有点瑕疵没有解决所以注释了，现在第二次加载就会出现，
                //谁解决了来说下，帮助大家
              }
              ctx.drawImage(img, -15, 10)
            }*/
          // 把当前画布返回（调整）到上一个save()状态之前
          ctx.restore();
          // 绘制奖品结束
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.adventures {
  .adven-popup {
    background-color: inherit;
    width: 80%;
  }
  .hintbox {
    position: relative;
    .hintclear {
      img {
        width: 20px;
      }
      position: absolute;
      right: 0;
      top: -30px;
    }
    .hinttit {
      font-size: 18px;
      text-align: center;
      padding: 15px 0;
    }
    .hintcent {
      background-color: #fff;
      border-radius: 10px;
      padding: 30px;
      background-image: url("/static/images/adven-adven-popup-tit.png");
      background-size: 100% auto;
      background-repeat: no-repeat;
      .tit {
        font-size: 16px;
      }
      p {
        font-size: 12px;
        line-height: 26px;
      }
      .van-button {
        height: 40px;
        padding: 0 40px;
        border-radius: 20px;
        margin-top: 20px;
        font-size: 16px;
        background: #fe2b3c;
        border: none;
        color: #fff !important;
        box-shadow: 0px 4px 30px #fe2b3c;
      }
    }
  }
  .userlist-popup {
    .hintcent {
      max-height: 400px;
      overflow-y: scroll;
      padding: 0;
      padding-top: 80px;
      box-sizing: border-box;
      padding-bottom: 20px;
      .hinttit {
        position: absolute;
        width: 100%;
        text-align: center;
        top: 0;
        padding-top: 30px;
        background-image: url(/static/images/adven-adven-popup-tit.jpg);
        background-size: 100%;
        border-radius: 15px;
      }
      .userlist {
        padding: 3.5px 30px;
      }
    }
  }
  .truetext {
    position: absolute;
    width: 100%;
    text-align: center;
    margin-top: 25%;
    top: 0;
    font-size: 16px;
  }
  .true-popup .hintcent {
    background-image: url("/static/images/adven-popup-truebg.png");
    background-size: 100% 100%;
    text-align: center;
    img {
      width: 150px;
      height: 116px;
      margin-top: 80px;
    }
  }
  .false-popup .hintcent {
    background-image: url("/static/images/adven-popup-falsebg.png");
    background-size: 100% 100%;
    text-align: center;
    height: 220px;
    img {
      width: 50px;
      margin-top: 110px;
    }
  }
  .van-content {
    padding-top: 0;
    margin-top: 46px;
    min-height: 100vh;
    background-image: url("/static/images/adventures-bg.png");
    background-size: 100% 100%;
    .usertit {
      background: #fee300;
      border: 1px solid #000;
      height: 30px;
      line-height: 30px;
      border-radius: 15px;
      width: 226px;
      position: absolute;
      left: 50%;
      margin-left: -113px;
      text-align: center;
      top: 34.5%;
      font-size: 14px;
      img {
        vertical-align: text-top;
        margin-right: 5px;
        width: 20px;
      }
    }
    .adventures-bot-btn {
      text-align: center;
      padding: 0 20px;
      .van-button {
        font-size: 16px;
        width: 120px;
        height: 40px;
        border-radius: 20px;
        box-shadow: 0px 4px 12px #333;
        margin-top: 12%;
      }
    }
  }
  .awardRotate {
    padding-top: 60%;
  }
  .banner {
    display: block;
    width: 95%;
    margin: 0 auto;
    margin-bottom: 20px;
  }
  .banner .turnplate {
    display: block;
    width: 100%;
    position: relative;
    padding: 0 5%;
    box-sizing: border-box;
  }
  .banner .turnplate canvas.item {
    width: 100%;
    background-image: url(/static/images/turnplate-bg.png);
    background-size: 100%;
  }
  .banner .turnplate img.pointer {
    position: absolute;
    width: 25%;
    height: 40.5%;
    left: 37.5%;
    top: 23%;
  }
  .turnplate-bottom {
    position: relative;
    bottom: 40px;
    box-sizing: border-box;
    width: 100%;
    top: 0;
    margin-top: -21%;
  }
}
/* 大转盘样式 */
</style>



// WEBPACK FOOTER //
// src/pages/activity/adventures.vue